<template>
  <div>
    <fidelior-carousel />
    <fidelior-about />
    <fidelior-fees />
    <div class="container-fluid">
      <div class="row p-3">
        <div class="col-md-2 d-none d-sm-block"></div>
        <div class="col-md-8 container-fluid">
          <div class="row">
            <div class="col-md-6">
              <fidelior-resources />
            </div>
            <div class="col-md-6">
              <fidelior-contact />
            </div>
          </div>
        </div>
        <div class="col-md-2 d-none d-sm-block"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "./fidelior-carousel.vue";
import About from "./fidelior-about.vue";
import Fees from "./fidelior-fees.vue";
import Resources from "./fidelior-resources.vue";
import Contact from "./fidelior-contact.vue";

export default {
  components: {
    "fidelior-carousel": Carousel,
    "fidelior-about": About,
    "fidelior-fees": Fees,
    "fidelior-resources": Resources,
    "fidelior-contact": Contact
  }
};
</script>
